import { render } from "./BlockDisplayBlock.vue?vue&type=template&id=44dd75a9&scoped=true&ts=true"
import script from "./BlockDisplayBlock.vue?vue&type=script&lang=ts"
export * from "./BlockDisplayBlock.vue?vue&type=script&lang=ts"

import "./BlockDisplayBlock.vue?vue&type=style&index=0&id=44dd75a9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dd75a9"]])

export default __exports__